// @generated by protoc-gen-es v1.7.2
// @generated from file proctoring/v1/session.proto (package proctoring.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3, Timestamp } from "@bufbuild/protobuf";
import { Interval } from "../../google/type/interval_pb.js";

/**
 * @generated from message proctoring.v1.Session
 */
export const Session = proto3.makeMessageType(
  "proctoring.v1.Session",
  () => [
    { no: 1, name: "key", kind: "message", T: Session_Key },
    { no: 2, name: "user_id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "assessment_id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message proctoring.v1.Session.Key
 */
export const Session_Key = proto3.makeMessageType(
  "proctoring.v1.Session.Key",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
  {localName: "Session_Key"},
);

/**
 * @generated from message proctoring.v1.SessionInfo
 */
export const SessionInfo = proto3.makeMessageType(
  "proctoring.v1.SessionInfo",
  () => [
    { no: 1, name: "session", kind: "message", T: Session },
    { no: 2, name: "started_at", kind: "message", T: Timestamp },
    { no: 3, name: "ended_at", kind: "message", T: Timestamp },
    { no: 4, name: "severity", kind: "enum", T: proto3.getEnumType(SessionInfo_Severity) },
  ],
);

/**
 * @generated from enum proctoring.v1.SessionInfo.Severity
 */
export const SessionInfo_Severity = proto3.makeEnum(
  "proctoring.v1.SessionInfo.Severity",
  [
    {no: 0, name: "SEVERITY_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "SEVERITY_NONE", localName: "NONE"},
    {no: 2, name: "SEVERITY_MINOR", localName: "MINOR"},
    {no: 3, name: "SEVERITY_MAJOR", localName: "MAJOR"},
    {no: 4, name: "SEVERITY_SEVERE", localName: "SEVERE"},
  ],
);

/**
 * @generated from message proctoring.v1.SessionServiceNewRequest
 */
export const SessionServiceNewRequest = proto3.makeMessageType(
  "proctoring.v1.SessionServiceNewRequest",
  () => [
    { no: 1, name: "user_id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "assessment_id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message proctoring.v1.SessionServiceNewResponse
 */
export const SessionServiceNewResponse = proto3.makeMessageType(
  "proctoring.v1.SessionServiceNewResponse",
  () => [
    { no: 1, name: "session_key", kind: "message", T: Session_Key },
  ],
);

/**
 * @generated from message proctoring.v1.SessionServiceEndRequest
 */
export const SessionServiceEndRequest = proto3.makeMessageType(
  "proctoring.v1.SessionServiceEndRequest",
  () => [
    { no: 1, name: "session_key", kind: "message", T: Session_Key },
    { no: 2, name: "sequence_number", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
  ],
);

/**
 * @generated from message proctoring.v1.SessionServiceEndResponse
 */
export const SessionServiceEndResponse = proto3.makeMessageType(
  "proctoring.v1.SessionServiceEndResponse",
  [],
);

/**
 * @generated from message proctoring.v1.SessionServiceGetRequest
 */
export const SessionServiceGetRequest = proto3.makeMessageType(
  "proctoring.v1.SessionServiceGetRequest",
  () => [
    { no: 1, name: "session_key", kind: "message", T: Session_Key },
  ],
);

/**
 * @generated from message proctoring.v1.SessionServiceGetResponse
 */
export const SessionServiceGetResponse = proto3.makeMessageType(
  "proctoring.v1.SessionServiceGetResponse",
  () => [
    { no: 1, name: "session", kind: "message", T: Session },
  ],
);

/**
 * @generated from message proctoring.v1.SessionServiceFindRequest
 */
export const SessionServiceFindRequest = proto3.makeMessageType(
  "proctoring.v1.SessionServiceFindRequest",
  () => [
    { no: 1, name: "user_id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "assessment_id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message proctoring.v1.SessionServiceFindResponse
 */
export const SessionServiceFindResponse = proto3.makeMessageType(
  "proctoring.v1.SessionServiceFindResponse",
  () => [
    { no: 1, name: "session", kind: "message", T: Session },
  ],
);

/**
 * @generated from message proctoring.v1.SessionServiceGetInfoRequest
 */
export const SessionServiceGetInfoRequest = proto3.makeMessageType(
  "proctoring.v1.SessionServiceGetInfoRequest",
  () => [
    { no: 1, name: "session_key", kind: "message", T: Session_Key },
  ],
);

/**
 * @generated from message proctoring.v1.SessionServiceGetInfoResponse
 */
export const SessionServiceGetInfoResponse = proto3.makeMessageType(
  "proctoring.v1.SessionServiceGetInfoResponse",
  () => [
    { no: 1, name: "session_info", kind: "message", T: SessionInfo },
  ],
);

/**
 * @generated from message proctoring.v1.SessionServiceFindInfoRequest
 */
export const SessionServiceFindInfoRequest = proto3.makeMessageType(
  "proctoring.v1.SessionServiceFindInfoRequest",
  () => [
    { no: 1, name: "user_id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "assessment_id", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "started_at", kind: "message", T: Interval },
  ],
);

/**
 * @generated from message proctoring.v1.SessionServiceFindInfoResponse
 */
export const SessionServiceFindInfoResponse = proto3.makeMessageType(
  "proctoring.v1.SessionServiceFindInfoResponse",
  () => [
    { no: 1, name: "session_info", kind: "message", T: SessionInfo },
  ],
);

/**
 * @generated from message proctoring.v1.SessionServiceUpdateInfoRequest
 */
export const SessionServiceUpdateInfoRequest = proto3.makeMessageType(
  "proctoring.v1.SessionServiceUpdateInfoRequest",
  () => [
    { no: 1, name: "session_info", kind: "message", T: SessionInfo },
  ],
);

/**
 * @generated from message proctoring.v1.SessionServiceUpdateInfoResponse
 */
export const SessionServiceUpdateInfoResponse = proto3.makeMessageType(
  "proctoring.v1.SessionServiceUpdateInfoResponse",
  [],
);

